import React, { useEffect, useState } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { cn } from "lib/utils"
import TemplatePreviewProvider from "lib/units/template/preview/TemplatePreviewProvider"
import TemplatePreview from "lib/designs/defleppard/TemplatePreview"

/* 
  === 
    TemplateRenderWrapper receives the complete Template object, along with the rp and subdomain values.
    These are passed on to the TemplatePreviewProvider, which is design-specific.
  ===
*/

export default function TemplateRenderWrapper({
  ready=false,
  template,
  rp,
  subdomain,
  renderconfig={ mode: "page", width: "1300px", height: "auto", scale: 1.0 }
}:{
  ready?:boolean
  template:any 
  rp:string
  subdomain:string
  renderconfig:{ mode:string, width:string, height:string, scale:number }
}) {

  const { store, AppStore }:any = appStore()
  const { update } = AppStore 

  // useEffect(() => {
  //   console.log(renderconfig)
  // },[renderconfig])

  if( !template || !rp || !subdomain || !ready ) return <></>
  return (
    <div 
      id="mm-pdf-render"
      className={cn(
        "*:text-gray-900 overflow-x-hidden overflow-y-auto"
      )}
      style={{
        maxWidth: renderconfig?.width || "1300px",
        width: renderconfig?.width || "920px",
        height: renderconfig?.height || "100vh",
        transform: renderconfig?.mode === "pdf" ? `scale(${renderconfig?.scale || 1.0})` : undefined,
      }}
    >
      <div id="mm-pdf-container">
        <TemplatePreviewProvider
          mode="render"
          datasource="api"
          rp={rp}
          subdomain={subdomain}
          template={template}
          renderconfig={renderconfig}
        >
          <TemplatePreview />
        </TemplatePreviewProvider>
      </div>
    </div>
  )
}


